import {
  AlignLeftOutlined,
  AlignRightOutlined,
  BarsOutlined,
  CalendarOutlined,
  CreditCardOutlined,
  ForkOutlined,
  RobotOutlined,
  ThunderboltOutlined,
  SettingOutlined,
  StarOutlined,
  UserOutlined,
  PoundOutlined,
  TagOutlined,
  TagsOutlined,
  SoundOutlined,
} from "@ant-design/icons";
import { ListingsPage } from "pages/admin/ListingsPage";
import { UsersPage } from "pages/admin/UsersPage";
import { RouteCategories } from "./enums";
import { AdminsPage } from "pages/superAdmin/AdminsPage";
import { LogInPage } from "pages/common/LogInPage";
import { ResetPasswordPage } from "pages/common/ResetPasswordPage";
import { RolesPage } from "../pages/superAdmin/RolesPage";
import { UserPage } from "../pages/admin/UserPage/UserPage";
import { TransactionsPage } from "../pages/admin/TransactionsPage";
import { ReportsPage } from "../pages/admin/ReportsPage";
import { ListingPage } from "../pages/admin/ListingPage/ListingPage";
import { IndexPage } from "../pages/admin/IndexPage";
import { TermsPage } from "../pages/admin/TermsPage";
import { CategoriesPage } from "../pages/admin/CategoriesPage/CategoriesPage";
import { ServicesPage } from "../pages/admin/ServicesPage/ServicesPage";
import { PolicyPage } from "../pages/admin/PolicyPage";
import { NotFoundPage } from "../pages/common/NotFoundPage";
import { NotificationsPage } from "../pages/admin/NotificationsPage";
import { PlatformSettingsPage } from "../pages/admin/PlatformSettingsPage";
import { EventsPage } from "../pages/admin/EventsPage/EventsPage";
import { EventEditPage } from "../pages/admin/EventsPage/EventEditPage";
import { RecommendedAccountsPage } from "../pages/admin/RecommendedAccountsPage/RecommendedAccountsPage";
import { BotsPage } from "../pages/superAdmin/BotsPage";
import { BotPage } from "../pages/superAdmin/BotPage/BotPage";
import { BotsBillingPage } from "../pages/superAdmin/BotsBillingPage/BotsBillingPage";
import { FeedPerformancePage } from "../pages/superAdmin/FeedPerformancePage";
import { AiModerationPage } from "../pages/superAdmin/AiModerationPage";

export const publicRoutes = [
  {
    name: "IndexPage",
    path: "/",
    element: <IndexPage />,
  },
  {
    name: "LogInPage",
    path: "/login",
    element: <LogInPage />,
  },
  {
    name: "ResetPasswordPage",
    path: "/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    name: "NotFoundPage",
    path: "/404",
    element: <NotFoundPage />,
  },
];

export const adminRoutes = [
  {
    name: "UsersPage",
    label: "Utilizatori",
    category: RouteCategories.USERS,
    path: "/users",
    element: <UsersPage />,
    icon: UserOutlined,
    permission: "isUsersRead",
  },
  {
    name: "UserPage",
    category: RouteCategories.USERS,
    path: "/users/:userId",
    element: <UserPage />,
    permission: "isUsersRead",
  },
  {
    name: "ListingsPage",
    label: "Anunturi",
    category: RouteCategories.LISTINGS,
    path: "/listings",
    element: <ListingsPage />,
    icon: BarsOutlined,
    permission: "isPostsRead",
  },
  {
    name: "ListingPage",
    category: RouteCategories.LISTINGS,
    path: "/listing/:listingId",
    element: <ListingPage />,
    permission: "isPostsRead",
  },
  {
    name: "TransactionsPage",
    label: "Tranzactii",
    category: RouteCategories.TRANSACTIONS,
    path: "/transactions",
    element: <TransactionsPage />,
    icon: PoundOutlined,
    permission: "isTransactionsRead",
  },
  {
    name: "ReportsPage",
    label: "Raportari",
    category: RouteCategories.REPORTS,
    path: "/reports",
    element: <ReportsPage />,
    icon: SoundOutlined,
    permission: "isReportsRead",
  },
  {
    label: "Categorii",
    category: RouteCategories.CATEGORIES,
    path: "/settings/categories",
    element: <CategoriesPage />,
    icon: TagOutlined,
    permission: "isCategoriesRead",
  },
  {
    label: "Servicii",
    category: RouteCategories.SERVICES,
    path: "/settings/services",
    element: <ServicesPage />,
    icon: TagsOutlined,
    permission: "isServicesRead",
  },
  {
    label: "Termeni",
    category: RouteCategories.TERMS,
    path: "/settings/terms",
    element: <TermsPage />,
    icon: AlignLeftOutlined,
  },
  {
    label: "Policy",
    category: RouteCategories.POLICY,
    path: "/settings/policy",
    element: <PolicyPage />,
    icon: AlignRightOutlined,
  },
  {
    name: "NotificationsPage",
    path: "/notifications",
    element: <NotificationsPage />,
  }
];

export const superAdminRoutes = [
  {
    name: "AdminsPage",
    label: "Administratori",
    category: RouteCategories.ADMINS,
    path: "/admins",
    element: <AdminsPage />,
    icon: UserOutlined,
    permission: "isUsersRead",
  },
  {
    name: "RolesPage",
    label: "Roluri",
    category: RouteCategories.ROLES,
    path: "/roles",
    element: <RolesPage />,
    icon: ForkOutlined,
    permission: "isUsersRead",
  },
  {
    name: "BotsPage",
    label: "Boti",
    category: RouteCategories.BOTS,
    path: "/bots",
    element: <BotsPage />,
    icon: RobotOutlined,
    permission: "isBotsRead",
  },
  {
    name: "BotPage",
    category: RouteCategories.BOTS,
    path: "/bots/:botId",
    element: <BotPage />,
    permission: "isBotsRead",
  },
  {
    name: "BotsBillingPage",
    label: "Facturare boti",
    category: RouteCategories.BOTS_BILLING,
    path: "/bots/billing",
    element: <BotsBillingPage />,
    icon: CreditCardOutlined,
    permission: "isBotsBillingManage",
  },
  {
    name: "PlatformSettingsPage",
    label: "Setari platforma",
    category: RouteCategories.PLATFORM_SETTINGS,
    path: "/settings/platform",
    element: <PlatformSettingsPage />,
    icon: SettingOutlined,
    permission: "isPlatformSettingsEdit",
  },
  {
    name: "EventsPage",
    label: "Evenimente",
    category: RouteCategories.EVENTS,
    path: "/events",
    element: <EventsPage />,
    icon: CalendarOutlined,
    permission: "isEventsRead",
  },
  {
    name: "EventCreatePage",
    category: RouteCategories.EVENTS,
    path: "/events/new",
    element: <EventEditPage />,
    permission: "isEventsEdit",
  },
  {
    name: "EventEditPage",
    category: RouteCategories.EVENTS,
    path: "/events/:id",
    element: <EventEditPage />,
    permission: "isEventsEdit",
  },
  {
    name: "RecommendedAccountsPage",
    label: "Conturi recomandate",
    category: RouteCategories.RECOMMENDED_ACCOUNTS,
    path: "/recommended-accounts",
    element: <RecommendedAccountsPage />,
    icon: StarOutlined,
    permission: "isRecommendedAccountsRead",
  },
  {
    name: "FeedPerformancePage",
    label: "Performanta feed",
    category: RouteCategories.FEED_PERFORMANCE,
    path: "/feed-performance",
    element: <FeedPerformancePage />,
    icon: ThunderboltOutlined,
    // Super-admin only: `isAll` is granted solely to the `all` permission,
    // so the sidebar filter (isAll || permission) shows this to superadmins.
    permission: "isAll",
  },
  {
    name: "AiModerationPage",
    label: "Moderare AI",
    category: RouteCategories.AI_MODERATION,
    path: "/ai-moderation",
    element: <AiModerationPage />,
    icon: ForkOutlined,
    // Super-admin only — same `isAll` gate as the feed-performance page.
    permission: "isAll",
  },
];

export const routes = [...publicRoutes, ...adminRoutes, ...superAdminRoutes];

export const flatAdminRoutes = adminRoutes.filter((i) => "category" in i);
export const flatSuperAdminRouter = superAdminRoutes.filter(
  (i) => "category" in i
);
